module.exports = __webpack_public_path__ + "img/1.4391f82d.png";